import { Target, BrainCircuit, ShieldCheck, Handshake } from 'lucide-react';
import ChooseUsImage from "@/assets/images/ITConsulting/it-consulting-why-us.webp";

const reasons = [
   {
		icon: Target,
		title: "Business-First Approach",
		description: "We design solutions focused on growth, efficiency, and scalability.",
	},
	{
		icon: BrainCircuit,
		title: "Deep Technical Expertise",
		description: "Our consultants bring certified expertise across modern technologies.",
	},
	{
		icon: ShieldCheck,
		title: "Security by Design",
		description: "Security is built into every solution from the start.",
	},
	{
		icon: Handshake,
		title: "True Partnership",
		description: "We work as an extension of your team with full transparency.",
	},
];

export default function WhyChooseUs() {
	return (
		<section className="relative pt-16 pb-12 md:pt-24 md:pb-16 overflow-hidden">
			{/* Animated background elements */}
			<div className="absolute inset-0 opacity-30">
				<div className="absolute top-40 left-20 w-72 h-72 bg-purple-500/20 rounded-full blur-3xl animate-pulse"></div>
				<div className="absolute bottom-40 right-20 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
			</div>

			<div className="container relative z-10">
				<div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">

					{/* ── Content ── */}
					<div className="lg:order-1 order-2">
						<div className="mb-8">
							<span className="inline-flex items-center gap-2 px-4 py-2 mb-6 bg-white/5 rounded-full border border-white/10 backdrop-blur-sm text-xs md:text-sm font-semibold text-gray-300 tracking-wider uppercase">
								Why Choose Us
							</span>
							<h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-snug">
								The Right Partner{" "}
								<span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">
									for What's Next
								</span>
							</h2>
						</div>

						<div className="grid grid-cols-1 gap-4">
							{reasons.map((item) => {
								const Icon = item.icon;
								return (
									<div
										key={item.title}
										className="group flex items-start gap-4 bg-white/5 backdrop-blur-sm border border-white/10 hover:border-purple-400/30 p-5 rounded-xl transition-all duration-300 hover:bg-white/10"
									>
										<div className="flex-shrink-0 bg-gradient-to-r from-purple-600 to-blue-600 p-3.5 rounded-lg group-hover:shadow-lg group-hover:shadow-purple-500/30 transition-shadow duration-300">
											<Icon size={22} className="text-white" />
										</div>
										<div>
											<h3 className="text-base font-semibold text-white mb-1">{item.title}</h3>
											<p className="text-sm leading-relaxed text-gray-400">{item.description}</p>
										</div>
									</div>
								);
							})}
						</div>
					</div>

					{/* ── Image ── */}
					<div className="lg:order-2 order-1 relative group">
						<div className="absolute inset-0 bg-gradient-to-r from-purple-500 to-blue-500 rounded-2xl blur-xl opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
						<div className="relative rounded-2xl overflow-hidden border border-white/10 bg-white/5 backdrop-blur-sm">
							<img
								src={ChooseUsImage}
								alt="Why Choose Us"
								className="w-full h-auto transform group-hover:scale-105 transition-transform duration-500"
							/>
						</div>
						<div className="absolute -top-4 -right-4 w-24 h-24 border-t-2 border-r-2 border-purple-400/50 rounded-tr-2xl"></div>
						<div className="absolute -bottom-4 -left-4 w-24 h-24 border-b-2 border-l-2 border-blue-400/50 rounded-bl-2xl"></div>
					</div>

				</div>
			</div>
		</section>
	);
}